var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"open-page-logo",on:{"click":_vm.goHome}},[_c('img',{class:{ 'custom-logo': _vm.hasCustomLogo },attrs:{"src":_vm.logoSrc,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }